<div class="main-report">
  <div
    class="main-slide-report-toc toc-sidebar"
    [ngClass]="isTocVisible ? 'toc-header-on' : 'toc-header-off'"
  >
    <piqet-angular-table-of-content
      [tocSections]="tocSections"
      [isTocVisible]="isTocVisible"
      (toggleBtn)="toggleToc($event)"
    ></piqet-angular-table-of-content>
  </div>

  <div [ngClass]="isTocVisible ? 'toc-content-on' : 'toc-content-off'">
    <div class="reportSpacing main-slide-report">
      <div>
        <div>
          <!-- Piqet Logo & Organization Logo -->
          <div
            class="logo-div d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-start align-items-md-center"
          >
            <div class="m-0 p-0">
              <img [src]="piqetLogo" id="piqetLogo" alt="Piqet logo" />
            </div>
            <div class="m-0 p-0" *ngIf="reportData?.organizationLogo">
              <img
                [src]="reportData?.organizationLogo"
                id="organizationLogo"
                alt="Organization image"
              />
            </div>
          </div>

          <!-- Project name -->
          <div class="main-contant">
            <div class="maintext-heading">
              <span class="purpleProjectName">{{ mainProjectName }}</span>
              {{ remainingProjectName }} -
              {{ reportResource.lblCompactReport | lowercase }}
            </div>
          </div>
          <!-- Scenario Image List -->
          <div
            class="left-align-padding d-flex flex-wrap gap-2"
            *ngIf="reportData?.scenarioImageList?.length"
          >
            <div *ngFor="let item of reportData?.scenarioImageList" class="w-fit-content">
              <img *ngIf="item?.imageName" [src]="item?.imageName" height="100" width="100" />
            </div>
          </div>
          <!-- Profile Image -->
          <div class="profile-detail-div">
            <div class="profile-image-div" *ngIf="reportData?.profileImage">
              <img
                [src]="'data:image/jpg;base64,' + reportData?.profileImage"
                alt="Profile image"
              />
            </div>
            <div class="profile-detail">
              <p class="userNameOrorganization">{{ reportData?.username }}</p>
            </div>
          </div>

          <div class="organizatio-name-div">
            <div class="organizatio-name">
              <p class="userNameOrorganization">{{ reportData?.organizationName }}</p>
            </div>
          </div>

          <!-- <div class="bottom-contant">
                  <div class="">Generated by</div>
                    <div class="">{{reportData?.username}}</div>
                    <div class="">{{reportData?.organizationName}}</div>
                </div> -->

          <div class="last-bottom-contant">
            <div class="">PIQET project code : {{ reportData?.projectCode }}</div>
            <div class="">Report generated : {{ reportData?.reportGenerateDate | date:'yyyy-MM-dd HH:mm'  }}</div>
            <div class="">Software version : PIQET {{ reportData?.softwareVersion }}</div>
          </div>
        </div>
      </div>

      <piqet-angular-toc-list [title]="'Figures'" [indexList]="figureIndexList">
      </piqet-angular-toc-list>

      <piqet-angular-toc-list [title]="'Tables'" [indexList]="tableIndexList">
      </piqet-angular-toc-list>
      <div>
        <div class="reportContent">
          <!-- Project detail -->
          <div class="project-detail-div page-break">
            <!-- Title -->
            <div class="row space" id="projectDetail">
              <div class="headingTitle">Project details</div>
            </div>
            <!-- Table & Table title -->
            <div class="row table-div">
              <div class="tableHeading">
                <div class="uniqTableSeq content-name-subtitle">
                  Table #1 : {{ reportResource.lblSummaryProject }}
                </div>
              </div>
              <div class="table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <td>PIQET project code</td>
                      <td>{{ reportData?.projectCode }}</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Name</td>
                      <td>{{ reportData?.projectName }}</td>
                    </tr>
                    <tr>
                      <td>Description</td>
                      <td>{{ reportData?.projectDescription }}</td>
                    </tr>
                    <tr>
                      <td>Share with</td>
                      <td>{{ reportData?.shareWith }}</td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td>{{ reportData?.status }}</td>
                    </tr>
                    <tr *ngIf="!reportData.isTurnOffCost">
                      <td>Currency</td>
                      <td>{{ reportData?.currency }}</td>
                    </tr>
                    <tr>
                      <td>Default country</td>
                      <td>{{ reportData?.defaultCountry }}</td>
                    </tr>
                    <tr>
                      <td>Other countries</td>
                      <td>{{ reportData?.otherCountries }}</td>
                    </tr>
                    <tr>
                      <td>Basis for comparison</td>
                      <td>{{ reportData?.basisforComparision }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- Table & Table title -->
            <div class="row table-div" *ngIf="reportData?.propackscenarioList.length > 0">
              <div class="tableHeading">
                <div class="uniqTableSeq content-name-subtitle">
                  Table #1 {{ reportResource.lblSummaryScenarios }}
                </div>
              </div>
              <div class="table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <td>Package product system</td>
                      <td>Package</td>
                      <td>Product</td>
                      <td>Product quantity</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let scenario of reportData?.propackscenarioList">
                      <td>{{ scenario.propackScenarioname }}</td>
                      <td>{{ scenario.package }}</td>
                      <td>{{ scenario.productSector }}</td>
                      <td>{{ scenario.productQuantity }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Scenario Comparison -->
          <div class="scenario-comparison-div">
            <!-- Title -->
            <div>
              <div class="page-break"></div>
              <div class="row space" id="scenarioComparison">
                <div class="headingTitle">Scenario comparison</div>
              </div>
            </div>
            <div
              *ngIf="
                reportData?.propackscenarioList.length >= 1 &&
                reportData?.lifeCycleStageContributionImpactItems.length >= 1
              "
            >
              <!-- Sub-title -->
              <div class="row sub-title-class">
                <div>
                  <div>At a glance comparison</div>
                </div>
              </div>
              <!-- Description -->
              <div style="margin: 10px 0px">
                <p class="para">
                  The following chart compares the relative impact of selected scenarios on equal
                  weighted indicators.
                </p>
                <p class="para">
                  Note: Spider diagram below shows relative impacts of scenarios being compared;
                  closer to the centre, lesser is the environmental impact.
                </p>
              </div>
            </div>
            <piqet-angular-life-cycle-impact-chart
              [SpiderChartItems]="reportData?.spiderChartItems"
            ></piqet-angular-life-cycle-impact-chart>
          </div>

          <div id="TotalImpactChartContainer" class="page-break"></div>

          <div>
            <div class="row space" id="graphicalSummary">
              <div class="sub-title-class">{{ reportResource.lblSummaryResult }}</div>
            </div>
          </div>
          <p class="figureIdClass uniqFigureSeq content-name-subtitle">
            Figure #1 : {{ reportResource.lblScenarioCategories }}
            -
            {{ reportData.functionalUnitName | lowercase }}
          </p>

          <div class="chartDesign">
            <div
              *ngFor="
                let indicatorDetail of reportData.lifeCycleStageContributionImpactItems;
                let i = index
              "
            >
              <div style="margin-bottom: 30px">
                <piqet-angular-life-cycle-stage-chart
                  [indicatorDetail]="indicatorDetail.impactItems"
                ></piqet-angular-life-cycle-stage-chart>
              </div>
            </div>
          </div>

          <!-- <div >
                  <div style="text-align: center;">
                    <span><i class="fa fa-square" aria-hidden="true"
                        style="color: #FBAB5A;"></i>{{reportResource.lblMaterial}}</span>
                    <span><i class="fa fa-square" aria-hidden="true" style="color: #FA736B; margin-left: 10px"></i>
                      {{reportResource.lblConversion}}</span>
                    <div *ngIf="reportData.isProductContent && !reportData.isExcludeProductImpacts ; else other_isProductContent">
                      <span><i class="fa fa-square" aria-hidden="true" style="color: #78CEB3; margin-left: 10px"></i>
                        {{reportResource.lblProductIngredient}}</span>
                      <span><i class="fa fa-square" aria-hidden="true" style="color: #60AAC1; margin-left: 10px"></i>
                        {{reportResource.lblProductManufacturing}}</span>
                      <span><i class="fa fa-square" aria-hidden="true" style="color: #A387BC; margin-left: 10px"></i>{{
                        reportResource.lblFilling}}</span>
                      <span><i class="fa fa-square" aria-hidden="true" style="color: #D07090; margin-left: 10px"></i>{{
                        reportResource.lblWholesale}}</span>
                      <span><i class="fa fa-square" aria-hidden="true" style="color: #9ACD32; margin-left: 10px"></i>
                        {{reportResource.lblRetail}}</span>
                      <span><i class="fa fa-square" aria-hidden="true" style="color: #C09090; margin-left: 10px"></i>
                        {{reportResource.lblConsumer}}</span>
                      <span><i class="fa fa-square" aria-hidden="true" style="color: #ADD8E6; margin-left: 10px"></i>
                        {{reportResource.lblEndLife}}</span>
                    </div>
                    <ng-template #other_isProductContent>
                      <span><i class="fa fa-square" aria-hidden="true" style="color: #78CEB3; margin-left: 10px"></i><b>
                          {{reportResource.lblFilling}}</b></span>
                      <span><i class="fa fa-square" aria-hidden="true" style="color: #60AAC1; margin-left: 10px"></i><b>{{
                          reportResource.lblWholesale}}</b></span>
                      <span><i class="fa fa-square" aria-hidden="true" style="color: #A387BC; margin-left: 10px"></i><b>
                          {{reportResource.lblRetail}}</b></span>
                      <span><i class="fa fa-square" aria-hidden="true" style="color: #D07090; margin-left: 10px"></i><b>
                          {{reportResource.lblConsumer}}</b></span>
                      <span><i class="fa fa-square" aria-hidden="true" style="color: #9ACD32; margin-left: 10px"></i><b>{{
                          reportResource.lblEndLife}}</b></span>
                    </ng-template>


                  </div>
                </div> -->

          <div
            *ngIf="reportData.isProductContent && !reportData.isExcludeProductImpacts"
            class="productDetails"
          >
            <ng-container *ngIf="reportData.productContributionItems.length > 0">
              <div class="page-break"></div>
              <div class="row space">
                <div class="headingTitle">{{ reportResource.lblProductDetails }}</div>
              </div>
              <div *ngFor="let data of reportData.productContributionItems">
                <piqet-angular-report-product-detail
                  [impactItems]="data"
                  [isExportFlag]="reportData.isExport"
                  [isApiCAll]="true"
                ></piqet-angular-report-product-detail>
              </div>
              <div class="row space">
                <div class="headingTitle">{{ reportResource.lblIngredientDataSource }}</div>
              </div>
              <div *ngFor="let item of reportData.productContributionItems">
                <piqet-angular-report-ingredientdatasource-details
                  [impactItems]="item"
                  [isExportFlag]="reportData.isExport"
                  [isApiCall]="true"
                ></piqet-angular-report-ingredientdatasource-details>
              </div>
            </ng-container>
          </div>

          <!-- packagingMatrics -->
          <div *ngIf="reportData?.additionalItems?.toLowerCase().includes('1')">
            <div class="page-break"></div>
            <div *ngIf="reportData.isExport; else other_packagingMatrics">
              <piqet-angular-packaging-matrics
                [packagingMatrics]="reportData?.packagingMatrics"
              ></piqet-angular-packaging-matrics>
            </div>
            <ng-template #other_packagingMatrics>
              <piqet-angular-packaging-matrics
                [packagingMatrics]="reportData?.packagingMatrics"
              ></piqet-angular-packaging-matrics>
            </ng-template>
          </div>

          <ng-container *ngIf="reportData.additionalItems.toLowerCase().includes('2')">
            <div class="page-break"></div>
            <div>
              <div class="row space" id="scenarioDetails">
                <div class="headingTitle">{{ reportResource.lblScenarioDetails }}</div>
              </div>
            </div>
            <ng-container *ngFor="let item of reportData.scenarioDetailItemList; let k = index">
              <div>
                <piqet-angular-report-scenario-detail
                  [impactItems]="item"
                  [isExport]="reportData.isExport"
                  [isCheckISO]="true"
                  [isProductContent]="reportData.isProductContent"
                  [scenarioDataList]="reportData.scenarioDetailItemList[k]"
                  [isExcludeProductImpacts]="reportData.isExcludeProductImpacts"
                  [processIncluded]="item?.projectProcessList"
                ></piqet-angular-report-scenario-detail>
              </div>
            </ng-container>
          </ng-container>

          <div class="row sub-title-class" id="resultsScenario">
            <div class="lblLifeCyclesStages">
              <div>{{ reportResource.lblResultScenario }}</div>
            </div>
          </div>
          <ng-container *ngFor="let item of reportData.scenarioContributionItems; let k = index">
            <div>
              <div class="tableHeading">
                <div>{{ item.scenarioName }} contribution analysis</div>
              </div>
            </div>
            <div style="margin-bottom: 30px">
              <piqet-angular-report-detail-contribution-chart
                [impactItems]="item.impactItems"
                [index]="k"
              ></piqet-angular-report-detail-contribution-chart>
            </div>
            <p class="figureIdClass uniqFigureSeq content-name-subtitle">
              Figure #1 : {{ reportResource.lblAllLifeCycle }} - {{ item.scenarioName }}
            </p>
          </ng-container>

          <div>
            <div
              class="contentMiniClass"
              id="sensitivityAnalysis"
              *ngIf="isHideSensitivityAnalysis"
            >
              <p class="content-name">Sensitivity analysis</p>
              <ng-container
                *ngIf="reportData?.sensitivityAnalysis?.length > 0; else noDataSensitivity"
              >
                <div class="content-text">
                  <ng-container
                    *ngIf="
                      reportData?.goalAndScope?.sensitivityAnalysisDescription?.trim();
                      else defaultSensitivityText
                    "
                  >
                    {{ reportData?.goalAndScope.sensitivityAnalysisDescription }} The following
                    sensitivity analyses were conducted:
                  </ng-container>

                  <ng-template #defaultSensitivityText>
                    Several scenarios were considered to shed light on how variations in input data
                    could affect the study results. The following sensitivity analyses were
                    conducted:
                  </ng-template>
                </div>
                <div *ngFor="let item of reportData?.sensitivityAnalysis">
                  <div class="contentMiniClass">
                    <p class="content-name-subtitle uniqTableSeq">
                      Table #1: Summary of sensitivity analysis
                    </p>
                    <div class="table-content my-2">
                      <table class="table">
                        <thead>
                          <tr>
                            <td>Variants</td>
                            <td>Short name</td>
                            <td>Long name</td>
                            <td>Scenario comment</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Reference</td>
                            <td>{{ item.variationDetail.shortName }}</td>
                            <td>{{ item.variationDetail.name }}</td>
                            <td>
                              {{
                                item.variationDetail.description == ''
                                  ? '–'
                                  : item.variationDetail.description
                              }}
                            </td>
                          </tr>
                          <ng-container
                            *ngFor="let childItem of item.variationDetail.childItems; let i = index"
                          >
                            <tr *ngIf="childItem.shortName && childItem.name">
                              <td>Variation {{ i + 1 }}</td>
                              <td>{{ childItem.shortName }}</td>
                              <td>{{ childItem.name }}</td>
                              <td>
                                {{ childItem.description == '' ? '–' : childItem.description }}
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="contentMiniClass">
                    <p class="content-name-subtitle uniqTableSeq">
                      Table #1: Sensitivity analysis results
                    </p>
                    <div class="table-content my-2">
                      <!-- <p class="content-text text-danger">DOne</p> -->
                      <table class="table">
                        <thead>
                          <tr>
                            <td></td>
                            <td
                              class="sensitivityAnalysis"
                              *ngFor="let childItem of item.variationDetail.childItems"
                            >
                              <ng-container *ngIf="childItem.name != '' && childItem.shortName"
                                >{{ childItem.name }} variation from
                                {{ item.variationDetail.name }}</ng-container
                              >
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="
                              let totalImpactItems of item?.sensitivityAnalysis;
                              let i = index
                            "
                          >
                            <td style="width: 30%">
                              {{ totalImpactItems.indicatorName }}
                              {{ totalImpactItems.indicatorUnitName }}
                            </td>
                            <ng-container
                              *ngFor="
                                let totalImpactItem of totalImpactItems.totalImpactValues.split(
                                  ';'
                                );
                                let j = index
                              "
                            >
                              <td
                                *ngIf="
                                  j < item.variationDetail.childItems.length &&
                                  item.variationDetail.childItems[j].name != ''
                                "
                              >
                                <span style="color: black">{{ totalImpactItem }}</span>
                              </td>
                            </ng-container>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="content-text">
                    These specific scenarios were designed to investigate the more uncertain and
                    biggest contributor to the {{ reportData?.baseScenarioName }}
                    environmental impacts.
                  </div>
                </div>
              </ng-container>

              <ng-template #noDataSensitivity>
                <div class="content-text">
                  {{ reportData?.organizationName }} did not include a sensitivity analysis in this
                  assessment.
                </div>
              </ng-template>
            </div>
          </div>

          <ng-container *ngIf="reportData.additionalItems.toLowerCase().includes('5')">
            <div class="page-break"></div>
            <div class="row space" id="categoryDefination">
              <div class="headingTitle">{{ reportResource.lblCatergoriesDefinition }}</div>
            </div>
            <div style="margin-bottom: 30px; margin-left: 8px">
              <piqet-angular-report-categories-definition
                [indicatorList]="reportData?.indicatorList"
                [isCheckISO]="true"
              ></piqet-angular-report-categories-definition>
            </div>
          </ng-container>

          <ng-container *ngIf="reportData.additionalItems.toLowerCase().includes('3')">
            <div class="page-break"></div>
            <div class="row space" id="dataSourceAtt">
              <div class="headingTitle">{{ reportResource.lblDataSource }}</div>
            </div>

            <div *ngFor="let item of reportData.scenarioContributionItems">
              <piqet-angular-report-data-source-etails
                [impactItems]="item"
                [isExportFlag]="reportData.isExport"
                [isApiCall]="true"
              ></piqet-angular-report-data-source-etails>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
